import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SaveWithoutContactsPopupData, SaveWithoutContactsPopupResult } from './save-without-contacts-popup';

// Bespoke dialog matching the "Save without any contacts?" mockup — full-width split action
// buttons and a plain (unbadged) warning triangle, rather than the shared confirmation-popup's
// stroked/flat buttons and circular icon badge. Kept as its own component (not a
// confirmation-popup variant) so this one-off look doesn't leak into the ~14 other dialogs that
// use confirmation-popup.
@Component({
  selector: 'app-save-without-contacts-popup',
  standalone: true,
  templateUrl: './save-without-contacts-popup.component.html',
  imports: [MatDialogTitle, MatDialogActions, MatDialogContent, MatIcon],
  styleUrl: './save-without-contacts-popup.component.scss'
})
export class SaveWithoutContactsPopupComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SaveWithoutContactsPopupData,
    private matDialogRef: MatDialogRef<SaveWithoutContactsPopupComponent, SaveWithoutContactsPopupResult>
  ) {}

  onConfirm() {
    this.matDialogRef.close('Confirmed');
  }

  onCancel() {
    this.matDialogRef.close();
  }
}
